import React from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  padding: 150px 40px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 950px) {
    padding: 150px 20px;
  }
`;

const Quote = styled.span`
  position: absolute;
  font-size: 80px;
  line-height: 1;
  color: ${colors.maroon};
  pointer-events: none;

  &:first-of-type {
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }

  &:last-of-type {
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Paragraph = styled.p`
  margin: 0;
  font-size: ${fontSize.s};
  color: ${colors.maroon};
`;

const Text = styled.p`
  margin-top: 16px;
  font-size: ${fontSize.s};
`;

function QuoteSection() {
  return (
    <Wrapper>
      <Quote>“</Quote>

      <Paragraph>
        The Himalayas teach humility, and the people who live among them carry
        patience and strength in every gesture. Their world, quiet yet
        extraordinary, is one I strive to honor in every creation.
      </Paragraph>

      <Text>- Founder on carrying the Himalayan legacy, 2025</Text>

      <Quote>”</Quote>
    </Wrapper>
  );
}

export default QuoteSection;
